import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";

/**
 * How many rows a list shows a page, and what else a reader may choose (#6713).
 *
 * Lists opened on 5, 10, 25 or 100 rows. They all open on 25 now, and every one offers the same four
 * sizes, so a reader who picks 50 on one list finds 50 on the next. `MRTNoMemo` applies both to every
 * list table; a page that keeps its own pagination state starts it from `LIST_PAGE_SIZE`. It is the
 * API's default page size, so a request that names no size asks for the page the table shows.
 */
export const LIST_PAGE_SIZE = PaginationParameters.DEFAULT_PAGE_SIZE;

export const LIST_PAGE_SIZE_OPTIONS: readonly number[] = [10, 25, 50, 100];
